import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} || MassDev </title>
                    <meta name="description" content="MassDev - Your Premier Web Development Experts in Jerusalem!" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
